if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        //this.submitButton.setAttribute('aria-disabled', true);
        //this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        this.querySelector('.product-form__submit').classList.add('loading_background');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              //this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.querySelector('.product-form__submit').classList.remove('loading_background');
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      /* toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      } */

        toggleSubmitButton(disable = true, text) {
          // Always keep enabled
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');

          // Always show Add to Cart
          this.submitButtonText.textContent = 'Add to cart';
        }


      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


/* For varient update */

if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', this.onVariantChange.bind(this));
      }

      onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateMedia();
        this.updatePrice();
        this.updateAddToCart();
      }

      updateOptions() {
        this.options = Array.from(this.querySelectorAll('select, input[type="radio"]:checked')).map(
          (element) => element.value
        );
      }

      updateMasterId() {
        const variant = this.getVariantData().find((v) => JSON.stringify(v.options) === JSON.stringify(this.options));

        if (!variant) return;

        const input = document.querySelector('.product-variant-id');
        input.value = variant.id;
      }

      updatePrice() {
        const variant = this.getCurrentVariant();
        if (!variant) return;

        const priceEl = document.querySelector('[data-sticky-price]');
        const compareEl = document.querySelector('[data-sticky-compare]');
        const discountEl = document.querySelector('[data-sticky-discount]');

        if (priceEl) priceEl.textContent = Shopify.formatMoney(variant.price);
        if (compareEl) {
          compareEl.textContent = variant.compare_at_price
            ? Shopify.formatMoney(variant.compare_at_price)
            : '';
          compareEl.style.display = variant.compare_at_price > variant.price ? 'inline' : 'none';
        }

        if (discountEl && variant.compare_at_price > variant.price) {
          const discount = Math.round(
            ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
          );
          discountEl.textContent = discount + '% OFF';
          discountEl.style.display = 'inline';
        } else if (discountEl) {
          discountEl.style.display = 'none';
        }
      }

      updateAddToCart() {
        const button = document.querySelector('.product-form__submit');

        if (button) {
          button.disabled = false;                     // Always enable
          button.removeAttribute('aria-disabled');     // Remove Shopify disable
          button.querySelector('span').innerText = 'Add to Cart'; // Always show Add to Cart
        }
      }



      getCurrentVariant() {
        return this.getVariantData().find((v) => JSON.stringify(v.options) === JSON.stringify(this.options));
      }

      getVariantData() {
        if (!this.variantData) {
          this.variantData = JSON.parse(
            document.querySelector('[data-variant-json]').textContent
          );
        }
        return this.variantData;
      }
    }
  );
}

/* CONNECT CUSTOM BUTTONS TO SHOPIFY VARIANT SYSTEM */
document.querySelectorAll('.varient_selector_content button').forEach(btn => {
  btn.addEventListener('click', function () {
    const wrapper = this.closest('.varient_selector_content');

    if (!wrapper) return;

    const optionName = wrapper.querySelector('.form__label').innerText.trim();
    const optionValue = this.innerText.trim();

    // UPDATE <select> VERSION
    const select = document.querySelector(`select[name="options[${optionName}]"]`);
    if (select) {
      select.value = optionValue;
      select.dispatchEvent(new Event("change"));
    }

    // UPDATE <input type="radio"> VERSION
    const radio = document.querySelector(`input[type="radio"][value="${optionValue}"]`);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change"));
    }
  });
});

